<template>
	<div class="cart-categories">
		<div class="cart-categories-row" v-if="category!='null'">
			<h5 class="category">{{ __(category) }}</h5>
			<span v-if="start_date" class="category-date">{{ __("Since") }} {{ start_date_display }}</span>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
	category: {
		type: String,
		default: () => null
	},
	start_date: {
		type: String,
		default: ""
	},
})

const start_date_display = computed(() => {
	return props.start_date ? frappe.datetime.obj_to_user(props.start_date) : ""
})
</script>

<style scoped style="scss">
.cart-categories {
	width: 100%;
	margin-bottom: 1rem;
	color: #4c5a67;
}

.cart-categories > td {
	border-top: none;
}

.cart-categories-row {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
}

.category {
	background-color: var(--primary);
	color: var(--white);
	white-space: nowrap;
	--icon-stroke: currentColor;
	--icon-fill-bg: var(--primary);
	border-radius: 4px;
	padding: 0.2rem;
	margin: 0;
}

/* Sits on the column's white background, not on .category's purple fill -
   light background / dark text, matching .cart-categories' own #4c5a67. */
.category-date {
	display: inline-flex;
	align-items: center;
	white-space: nowrap;
	padding: 2px 8px;
	border-radius: 6px;
	font-size: .72rem;
	background: #EEF0F2;
	color: #4c5a67;
}

</style>